import states from './states';

export const stateEnums = states.map(({ stateCode, stateName }) => ({
  value: stateCode,
  option: stateName,
}));

export const mailingStateEnums = stateEnums.concat([
  { value: 'AS', option: 'American Samoa' },
  { value: 'GU', option: 'Guam' },
  { value: 'MP', option: 'Northern Mariana Islands' },
  { value: 'PR', option: 'Puerto Rico' },
  { value: 'VI', option: 'U.S. Virgin Islands' },
]);

export const titleEnums = [
  { value: '', option: '--' },
  { value: 'Mr', option: 'Mr.', gender: 'Male' },
  { value: 'Mrs', option: 'Mrs.', gender: 'Female' },
  { value: 'Miss', option: 'Miss', gender: 'Female' },
  { value: 'Ms', option: 'Ms.', gender: 'Female' },
  { value: 'Mx', option: 'Mx.', forbiddenStates: ['TN'], gender: 'Other' },
];

export const suffixEnums = [
  { value: '', option: '--' },
  { value: 'Jr', option: 'Jr.' },
  { value: 'Sr', option: 'Sr.' },
  { value: 'II', option: 'II' },
  { value: 'III', option: 'III' },
  { value: 'IV', option: 'IV' },
];

export const monthEnums = [
  { value: '', option: 'Select a month' },
  { value: '01', option: 'January' },
  { value: '02', option: 'February' },
  { value: '03', option: 'March' },
  { value: '04', option: 'April' },
  { value: '05', option: 'May' },
  { value: '06', option: 'June' },
  { value: '07', option: 'July' },
  { value: '08', option: 'August' },
  { value: '09', option: 'September' },
  { value: '10', option: 'October' },
  { value: '11', option: 'November' },
  { value: '12', option: 'December' },
];

export const partyEnums = [
  { value: '', option: 'Select a party' },
  { value: 'Democratic', option: 'Democratic' },
  { value: 'Republican', option: 'Republican' },
  { value: 'Green', option: 'Green' },
  { value: 'Libertarian', option: 'Libertarian' },
  { value: 'None', option: 'None' },
  { value: 'Other', option: 'Other' },
];

export const raceEthnicityEnums = [
  { value: '', option: 'Select' },
  { value: 'Native', option: 'American Indian / Alaskan Native' },
  { value: 'AAPI', option: 'Asian / Pacific Islander' },
  { value: 'Black', option: 'Black (not Hispanic)' },
  { value: 'Hispanic', option: 'Hispanic' },
  { value: 'Multi', option: 'Multi Racial' },
  { value: 'White', option: 'White (not Hispanic)' },
  { value: 'Other', option: 'Other' },
];
